import { render } from "./LinkedIn.vue?vue&type=template&id=c1bcd79a"
const script = {}
script.render = render

export default script